import React, { FC } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { FieldProps } from 'formik';
import { Close, Search } from '@mui/icons-material';

export const SearchControl: FC<FieldProps> = ({ field, form, ...props }) => (
  <TextField
    fullWidth
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Search />
        </InputAdornment>
      ),
      endAdornment: field.value && (
        <InputAdornment position="end">
          <IconButton onClick={() => form.setFieldValue(field.name, '')} size="large">
            <Close />
          </IconButton>
        </InputAdornment>
      ),
    }}
    {...field}
    {...props}
  />
);
